import type { ComponentType } from 'react'

interface IntegrationLogoStripProps {
  className?: string
  onDark?: boolean
}

interface IntegrationMarkProps {
  className?: string
}

export function NotionLogoMark({ className }: IntegrationMarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path fill="currentColor" d="M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.981-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.887l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.139c-.093-.514.28-.887.747-.933zM1.936 1.035l13.31-.98c1.634-.14 2.055-.047 3.082.7l4.249 2.986c.7.513.934.653.934 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.667c0-.839.374-1.54 1.447-1.632z" />
    </svg>
  )
}

export function LinearLogoMark({ className }: IntegrationMarkProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
      <path fill="currentColor" d="M1.22541 61.5228c-.2225-.9485.90748-1.5459 1.59638-.857L39.3342 97.1782c.6889.6889.0915 1.8189-.857 1.5964C20.0515 94.4522 5.54779 79.9485 1.22541 61.5228ZM.00189135 46.8891c-.01764375.2833.08887215.5599.28957165.7606L52.3503 99.7085c.2007.2007.4773.3075.7606.2896 2.3692-.1476 4.6938-.46 6.9624-.9259.7645-.157 1.0301-1.0963.4782-1.6481L2.57595 39.4485c-.55186-.5519-1.49117-.2863-1.648174.4782-.465915 2.2686-.77832 4.5932-.92588465 6.9624ZM4.21093 29.7054c-.16649.3738-.08169.8106.20765 1.1l64.77602 64.776c.2894.2894.7262.3742 1.1.2077 1.7861-.7956 3.5171-1.6927 5.1855-2.684.5521-.328.6373-1.0867.1832-1.5407L8.43566 24.3367c-.45409-.4541-1.21271-.3689-1.54074.1832-.99132 1.6684-1.88843 3.3994-2.68399 5.1855ZM12.6587 18.074c-.3701-.3701-.393-.9637-.0443-1.3541C21.7795 6.45931 35.1114 0 49.9519 0 77.5927 0 100 22.4073 100 50.0481c0 14.8405-6.4593 28.1724-16.7199 37.3375-.3903.3487-.984.3258-1.3542-.0443L12.6587 18.074Z" />
    </svg>
  )
}

function SlackLogoMark({ className }: IntegrationMarkProps) {
  return (
    <svg viewBox="0 0 54 54" className={className} aria-hidden="true">
      <path d="M11.379 33.9993c0 3.1365-2.53388 5.6514-5.6514 5.6514S.0572 37.1168.0572 33.9993s2.5339-5.6514 5.6514-5.6514h5.6514v5.6514h.019Z" fill="#E01E5A" />
      <path d="M14.1962 33.9997c0-3.1365 2.5339-5.6514 5.6514-5.6514s5.6514 2.5339 5.6514 5.6514v14.1356c0 3.1365-2.5339 5.6514-5.6514 5.6514s-5.6514-2.5149-5.6514-5.6514V33.9997Z" fill="#E01E5A" />
      <path d="M19.8662 11.2673c-3.1366 0-5.6514-2.5338-5.6514-5.6514 0-3.1175 2.5338-5.6514 5.6514-5.6514 3.1175 0 5.6513 2.5339 5.6513 5.6514v5.6514h-5.6513Z" fill="#36C5F0" />
      <path d="M19.8682 14.1334c3.1365 0 5.6514 2.5339 5.6514 5.6514s-2.5339 5.6514-5.6514 5.6514H5.6757c-3.1365 0-5.6514-2.5339-5.6514-5.6514s2.5339-5.6514 5.6514-5.6514h14.1925Z" fill="#36C5F0" />
      <path d="M42.5323 19.7853c0-3.1365 2.5339-5.6514 5.6514-5.6514s5.6514 2.5339 5.6514 5.6514-2.5339 5.6514-5.6514 5.6514h-5.6514v-5.6514Z" fill="#2EB67D" />
      <path d="M39.7126 19.7934c0 3.1365-2.5339 5.6514-5.6514 5.6514s-5.6514-2.5338-5.6514-5.6514V5.6199c0-3.1365 2.5338-5.6514 5.6514-5.6514s5.6514 2.5149 5.6514 5.6514v14.1735Z" fill="#2EB67D" />
      <path d="M34.0376 42.482c3.1365 0 5.6514 2.5338 5.6514 5.6514 0 3.1175-2.5338 5.6514-5.6514 5.6514-3.1175 0-5.6514-2.5339-5.6514-5.6514V42.482h5.6514Z" fill="#ECB22E" />
      <path d="M34.0381 39.6507c-3.1365 0-5.6514-2.5339-5.6514-5.6514s2.5339-5.6514 5.6514-5.6514h14.1925c3.1365 0 5.6514 2.5339 5.6514 5.6514s-2.5338 5.6514-5.6514 5.6514H34.0381Z" fill="#ECB22E" />
    </svg>
  )
}

function MicrosoftLogoMark({ className }: IntegrationMarkProps) {
  return (
    <svg viewBox="0 0 28 28" className={className} aria-hidden="true">
      <path d="M3 3h10v10H3z" fill="#F25022" />
      <path d="M15 3h10v10H15z" fill="#7FBA00" />
      <path d="M3 15h10v10H3z" fill="#00A4EF" />
      <path d="M15 15h10v10H15z" fill="#FFB900" />
    </svg>
  )
}

const integrations: Array<{
  name: string
  Mark: ComponentType<IntegrationMarkProps>
  className?: string
}> = [
  {
    name: 'Notion',
    Mark: NotionLogoMark,
  },
  {
    name: 'Linear',
    Mark: LinearLogoMark,
  },
  {
    name: 'Slack',
    Mark: SlackLogoMark,
  },
  {
    name: 'Microsoft 365',
    Mark: MicrosoftLogoMark,
    className: 'integration-logo--microsoft',
  },
]

export function IntegrationLogoStrip({ className = '', onDark = false }: IntegrationLogoStripProps) {
  return (
    <div className={`integration-logo-strip${onDark ? ' integration-logo-strip--dark' : ''} ${className}`.trim()} aria-label="Works with Notion, Linear, Slack, and Microsoft 365">
      {integrations.map(({ name, Mark, className: brandClassName }) => (
        <span className={`integration-logo ${brandClassName || ''}`.trim()} key={name}>
          <Mark />
          <b>{name}</b>
        </span>
      ))}
    </div>
  )
}

export default IntegrationLogoStrip
